import { render, staticRenderFns } from "./Inviters.vue?vue&type=template&id=1216088f&scoped=true"
import script from "./Inviters.vue?vue&type=script&lang=js"
export * from "./Inviters.vue?vue&type=script&lang=js"
import style0 from "./Inviters.vue?vue&type=style&index=0&id=1216088f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1216088f",
  null
  
)

export default component.exports